const isElectron = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  if ((window as any)?.Ionic?.platforms?.includes?.('electron')) {
    return true;
  }

  const processRef = (window as any)?.process;
  if (processRef?.type === 'renderer') {
    return true;
  }

  if (typeof process !== 'undefined' && (process as any)?.versions?.electron) {
    return true;
  }

  return (
    typeof navigator === 'object' &&
    typeof navigator.userAgent === 'string' &&
    navigator.userAgent.includes('Electron')
  );
};

export default isElectron;
